import React, { useState } from "react";
import ImageReplaceWithPicker from "./ImageReplaceWithPicker";
import { useTheme, useMediaQuery } from "@mui/material";
import { Box, Typography, Button } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import UserPhotosLayout from "../ChatMessenger/bot-profile-chat/UserPhotosLayout";
const UserPhotosWrapper = ({
  publicPhotosProps,
  privatePhotosProps,
  profileImage,
  isOnLine,
  isDeletedAccount
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [memberData, setMemberData] = useState({ isLiked: false });

  const handleUserAction = () => {
    setMemberData((prev) => ({ ...prev, isLiked: !prev.isLiked }));
  }
  const [publicPhotos, setPublicPhotos] = useState(publicPhotosProps);
  const [privatePhotos, setPrivatePhotos] = useState(privatePhotosProps);
  const allPhotos = [...publicPhotosProps, ...privatePhotosProps];

  return (
    <>
      <ImageReplaceWithPicker
        isOnLine={isOnLine}
        isDeletedAccount={isDeletedAccount}
        profileImage={profileImage}
        photos={isMobile ? allPhotos : []}
      />
      <UserPhotosLayout
        photos={publicPhotosProps}
        setPhotos={setPublicPhotos}
        title="Public Photos"
        isEditable={false}
        showExtraCount={true}
      />
      <Box sx={{ paddingTop: { xs: '15px', sm: '0' } }}>
        <UserPhotosLayout
          photos={privatePhotosProps}
          setPhotos={setPrivatePhotos}
          title="Private Photos"
          isEditable={false}
          showExtraCount={true}
          isPrivate={true}
        />
      </Box>
      {/* <Box my={2} mx="12px" sx={{ backgroundColor: '#F9F5F2', borderRadius: '12px', padding: ' 16px 12px', display: { xs: 'none', sm: 'block' } }}>
        <Typography display="flex" alignItems="center" gap="16px" fontsize={20} fontWeight={600} color="#6A513E">
          <img src='./assets/images/user-profile/exclusive-lock.svg' alt='exclusive' class="img-fluid" />
          Exclusive Access
        </Typography>
        <Typography mt={2} fontsize={14} fontWeight={400} color="#000000">
          Connect to unlock private photos shared only with verified members.
        </Typography>
      </Box> */}
      {/* <Box sx={{ m: { xs: '15px 0 0 0', sm: "15px 12px" } }}>
        <Button variant="contained"
          display="flex"
          sx={{
            width: '100%',
            backgroundColor: '#2B1E1A',
            color: '#fff',
            fontSize: '15px',
            borderRadius: '100px',
            paddingX: 3,
            paddingY: 1,
            fontWeight: '600',
            textTransform: 'none',
            gap: 2,
            boxShadow: '0 1px 2px #FEA3194D',
            whiteSpace: 'nowrap',
            '&:hover': {
              backgroundColor: '#2B1E1A',
            },
          }}>
          Request Private Photos
          <img src='./assets/images/user-profile/upgrade.svg' alt='Upgrade' class="img-fluid" />
        </Button>
      </Box> */}
      {/* <Box mx="12px" sx={{ display: 'flex', gap: 2, mt: '34px', mb: '16px', display: { xs: 'none', sm: 'flex' } }}>
        <Button
          variant="contained"
          onClick={() => handleUserAction("Favorite")}
          sx={{
            width: '100%',
            backgroundColor: memberData?.isLiked ? '#EA4335' : '#ff8a8a',
            boxShadow: 'unset',
            color: '#fff',
            fontSize: '15px',
            borderRadius: '100px',
            px: 3,
            py: 1,
            fontWeight: 600,
            textTransform: 'none',
            gap: 1,
            whiteSpace: 'nowrap',
            '&:hover': {
              backgroundColor: '#EA4335',
            },
          }}
        >
          <FavoriteIcon />
          {memberData?.isLiked ? "Liked" : "Like profile"}
        </Button>

        <Button variant="outlined"
          display="flex"
          sx={{
            width: '100%',
            backgroundColor: '#fff',
            border: '1px solid #E0E2E9',
            color: '#2B1E1A',
            fontSize: '15px',
            borderRadius: '100px',
            paddingX: 3,
            paddingY: 1,
            fontWeight: '600',
            textTransform: 'none',
            gap: 1,
            whiteSpace: 'nowrap',
            '&:hover': {
              backgroundColor: '#fff',
            },
          }}>
          <img src='./assets/images/user-profile/close-small.svg' class="img-fluid" alt='close' />
          Hide
        </Button>
      </Box> */}
    </>
  );
};

export default UserPhotosWrapper;
